module.exports = __webpack_public_path__ + "static/media/plus-sign.ebe8d38a.svg";